import { PRICING_MODELS_BY_MEDIA_TYPE } from 'sonata-static-storage/lib/samples/pricingModels.samples';

// biome-ignore-all lint/complexity/noUselessStringConcat: off
import defaultConfig from '../../config/default.json';
import { allCountries } from './allCountries.ts';
import config from './config.ts';
import { getPlatformPermissions } from './helpers/getPlatformPermissions';

export const loadTaptapConfig = async () => {
  const sonataUrl = config.sonataUrl || defaultConfig.sonataUrl;
  const sonataV2Url = config.sonataV2Url || defaultConfig.sonataV2Url;
  const backendUrlBase = `${config.sonataBackendUrl}`;
  const mapbox = {
    accessToken: 'pk.eyJ1IjoidGFwdGFwIiwiYSI6IjRSaHpHbUEifQ.2bAMMlWkzbPiVWA6dCE2Wg',
    geocoderURL: 'geocoding/v5/mapbox.places/',
    url: 'https://api.mapbox.com/'
  };

  if (typeof window !== 'undefined') {
    window.taptap = {
      allCountries,
      app: {
        platformPermissions: []
      },
      config: {
        ...defaultConfig,
        ...config,
        adserverPixelTracks: {
          conversion: {
            image: 'https://ads.sonataplatform.com/pixel/attribution',
            script: {
              persist: 'https://public.sonataplatform.com/sonataPersist.min.js',
              track: 'https://public.sonataplatform.com/sonataTrack.min.js'
            }
          },
          stay: {
            script: {
              v1: 'https://ads.sonataplatform.com/pixel/script/conversion/proctimeout',
              v2: 'https://ads.sonataplatform.com/pixel/script/conversion/permanence'
            }
          }
        },
        backendUrlBase,
        inventoryExplorerMapToken: `${config.inventoryExplorerMapToken || defaultConfig.inventoryExplorerMapToken}`,
        mapbox,
        mbtilesServer: 'https://tiles.sonataplatform.com/',
        sonataAppUrl: `${sonataUrl}${config.sonataApp || defaultConfig.sonataApp}`,
        sonataAppV2Url: `${sonataV2Url}${config.sonataV2App || defaultConfig.sonataV2App}`,
        sonataManagementAppUrl: `${sonataUrl}${config.managementApp || defaultConfig.managementApp}`,
        sonataManagementAppV2Url: `${config.managementAppV2}`,
        sonataStaticsUrlBase: '//statics.sonataplatform.com',
        sonataUrl
      },
      entity: {
        model: undefined,
        validationErrors: undefined
      },
      pricingModels: PRICING_MODELS_BY_MEDIA_TYPE,
      tools: {
        validateUrl: (url: string) => {
          const urlRegExp = new RegExp(
            '^' +
              // protocol identifier
              '(?:(?:https?|ftp)://)' +
              // user:pass authentication
              '(?:\\S+(?::\\S*)?@)?' +
              '(?:' +
              // IP address exclusion
              // private & local networks
              '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
              '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
              '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
              // IP address dotted notation octets
              // excludes loopback network 0.0.0.0
              // excludes reserved space >= 224.0.0.0
              // excludes network & broacast addresses
              // (first & last IP address of each class)
              '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
              '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
              '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
              '|' +
              // reject www-only domains (e.g. https://www.com)
              '(?!www\\.(?:[a-z\\u00a1-\\uffff]{2,})\\.?(?:[/?#:]|$))' +
              // host name
              '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)' +
              // domain name
              '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*' +
              // TLD identifier
              '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))' +
              // TLD may end with dot
              '\\.?' +
              ')' +
              // port number
              '(?::\\d{2,5})?' +
              // resource path
              '(?:[/?#]\\S*)?' +
              '$',
            'i'
          );
          return urlRegExp.test(url);
        }
      }
    };
    const platformPermissions = await getPlatformPermissions(backendUrlBase);
    taptap.app.platformPermissions = platformPermissions;
  }
};
